import React, { useState } from 'react';

const SMART_STEPS = [
  { 
    id: 'S', 
    title: 'Específica (Specific)', 
    label: '¿Qué habilidad de inglés quieres mejorar exactamente?', 
    placeholder: 'Ej. Quiero mejorar mi fluidez al hablar (Speaking) y dominar el vocabulario de negocios...' 
  },
  { 
    id: 'M', 
    title: 'Medible (Measurable)', 
    label: '¿Cómo vas a medir tu progreso en el idioma?', 
    placeholder: 'Ej. Manteniendo una conversación fluida de 15 minutos o aprendiendo 5 palabras nuevas al día...' 
  },
  { 
    id: 'A', 
    title: 'Alcanzable (Achievable)', 
    label: '¿Tienes el tiempo y los recursos? ¿Qué vas a usar para estudiar?', 
    placeholder: 'Ej. Sí, tengo 30 minutos al día. Usaré una app de intercambio de idiomas y veré series con subtítulos...' 
  },
  { 
    id: 'R', 
    title: 'Relevante (Relevant)', 
    label: '¿Por qué es importante para ti hablar inglés en este momento?', 
    placeholder: 'Ej. Para poder aplicar a puestos internacionales y mejorar mis ingresos...' 
  },
  { 
    id: 'T', 
    title: 'Temporal (Time-bound)', 
    label: '¿Cuál es tu fecha límite para lograr esta meta?', 
    placeholder: '' 
  },
  {
    id: 'REVIEW',
    title: 'Revisión de tu Meta SMART',
    label: 'Verifica tu objetivo. Puedes editar cualquier sección antes de guardarla.',
    placeholder: ''
  }
];

export default function SmartGoalModal({ isOpen, onClose, onSubmit }) {
  const [currentStep, setCurrentStep] = useState(0);
  const [formData, setFormData] = useState({
    S: '', M: '', A: '', R: '', T: ''
  });

  if (!isOpen) return null;

  const stepConfig = SMART_STEPS[currentStep];
  const isFirstStep = currentStep === 0;
  const isLastStep = currentStep === SMART_STEPS.length - 1; 
  const isTimeStep = stepConfig.id === 'T';
  const isReviewStep = stepConfig.id === 'REVIEW';

  const isCurrentFieldEmpty = !isReviewStep && !formData[stepConfig.id]?.trim();

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [stepConfig.id]: e.target.value
    });
  };

  const handleNext = (e) => {
    e.preventDefault(); 
    if (!isLastStep && !isCurrentFieldEmpty) {
      setCurrentStep((prev) => prev + 1);
    }
  };

  const handleBack = () => {
    if (!isFirstStep) {
      setCurrentStep((prev) => prev - 1);
    }
  };

  // NUEVA FUNCIÓN: Salta directamente al paso del parámetro para permitir edición
  const handleJumpToStep = (stepIndex) => {
    setCurrentStep(stepIndex);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isReviewStep && onSubmit) {
      onSubmit(formData);
      setFormData({ S: '', M: '', A: '', R: '', T: '' });
      setCurrentStep(0);
      onClose();
    }
  };

  return (
    <div className="modal-overlay" style={styles.overlay}>
      <div className="modal-content" style={styles.modal}>
        
        {/* Encabezado */}
        <div style={styles.header}>
          <h2 style={styles.headerTitle}>Nueva Meta SMART</h2>
          <button type="button" onClick={onClose} style={styles.closeBtn} title="Cerrar">&times;</button>
        </div>

        {/* Barra de progreso */}
        <div style={styles.progressContainer}>
          <span style={styles.progressText}>
            {isReviewStep ? 'Paso Final: Revisión' : `Paso ${currentStep + 1} de ${SMART_STEPS.length - 1}`}
          </span>
          <div style={styles.progressBarOuter}>
            <div 
              style={{ 
                ...styles.progressBarInner, 
                width: `${((currentStep + 1) / SMART_STEPS.length) * 100}%` 
              }} 
            />
          </div>
        </div>

        {/* Formulario */}
        <form onSubmit={handleSubmit} style={styles.form}>
          
          {/* PASOS DE TEXTO (S, M, A, R) */}
          {!isTimeStep && !isReviewStep && (
            <div style={styles.stepContainer}>
              <h3 style={styles.stepTitle}>{stepConfig.title}</h3>
              <label style={styles.label}>{stepConfig.label}</label>
              <textarea
                value={formData[stepConfig.id]}
                onChange={handleInputChange}
                placeholder={stepConfig.placeholder}
                style={styles.textarea}
                required
              />
            </div>
          )}

          {/* PASO T (FECHA) */}
          {isTimeStep && (
            <div style={styles.stepContainer}>
              <h3 style={styles.stepTitle}>{stepConfig.title}</h3>
              <label style={styles.label}>{stepConfig.label}</label>
              <input
                type="date"
                value={formData.T}
                onChange={handleInputChange}
                style={styles.dateInput}
                required
              />
            </div>
          )}

          {/* PASO DE REVISIÓN CON ENLACES DE EDICIÓN INDIRECTA */}
          {isReviewStep && (
            <div style={styles.stepContainer}>
              <h3 style={styles.stepTitle}>{stepConfig.title}</h3>
              <p style={styles.label}>{stepConfig.label}</p>
              
              <div style={styles.reviewContainer}>
                
                {/* Elemento S */}
                <div style={styles.reviewItem}>
                  <div style={styles.reviewItemHeader}>
                    <strong>Specific (Específica):</strong>
                    <button type="button" onClick={() => handleJumpToStep(0)} style={styles.editBtn}>Editar</button>
                  </div>
                  <p style={styles.reviewText}>{formData.S}</p>
                </div>

                {/* Elemento M */}
                <div style={styles.reviewItem}>
                  <div style={styles.reviewItemHeader}>
                    <strong>Measurable (Medible):</strong>
                    <button type="button" onClick={() => handleJumpToStep(1)} style={styles.editBtn}>Editar</button>
                  </div>
                  <p style={styles.reviewText}>{formData.M}</p>
                </div>

                {/* Elemento A */}
                <div style={styles.reviewItem}>
                  <div style={styles.reviewItemHeader}>
                    <strong>Achievable (Alcanzable):</strong>
                    <button type="button" onClick={() => handleJumpToStep(2)} style={styles.editBtn}>Editar</button>
                  </div>
                  <p style={styles.reviewText}>{formData.A}</p>
                </div>

                {/* Elemento R */}
                <div style={styles.reviewItem}>
                  <div style={styles.reviewItemHeader}>
                    <strong>Relevant (Relevante):</strong>
                    <button type="button" onClick={() => handleJumpToStep(3)} style={styles.editBtn}>Editar</button>
                  </div>
                  <p style={styles.reviewText}>{formData.R}</p>
                </div>

                {/* Elemento T */}
                <div style={styles.reviewItem}>
                  <div style={styles.reviewItemHeader}>
                    <strong>Time-bound (Fecha Límite):</strong>
                    <button type="button" onClick={() => handleJumpToStep(4)} style={styles.editBtn}>Editar</button>
                  </div>
                  <p style={styles.reviewText}>
                    {formData.T ? new Date(formData.T).toLocaleDateString('es-MX', { timeZone: 'UTC', dateStyle: 'long' }) : 'No definida'}
                  </p>
                </div>

              </div>
            </div>
          )}

          {/* Botones del Footer */}
          <div style={styles.actions}>
            <button
              type="button"
              onClick={handleBack}
              disabled={isFirstStep}
              style={{ 
                ...styles.btn, 
                ...(!isFirstStep ? styles.btnBackActive : styles.btnDisabled) 
              }}
            >
              Regresar
            </button>

            {!isReviewStep ? (
              <button
                type="button"
                onClick={handleNext}
                disabled={isCurrentFieldEmpty}
                style={{ 
                  ...styles.btn, 
                  ...(!isCurrentFieldEmpty ? styles.btnNextActive : styles.btnDisabled) 
                }}
              >
                Siguiente
              </button>
            ) : (
              <button
                type="submit"
                style={{ ...styles.btn, ...styles.btnSubmitActive }}
              >
                Confirmar y Guardar Meta
              </button>
            )}
          </div>
        </form>

      </div>
    </div>
  );
}

// Estilos actualizados con el nuevo botón de edición rápida
const styles = {
  overlay: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(15, 23, 42, 0.6)', backdropFilter: 'blur(4px)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000 },
  modal: { backgroundColor: '#ffffff', padding: '28px', borderRadius: '12px', width: '90%', maxWidth: '550px', maxHeight: '90vh', overflowY: 'auto', boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1)', fontFamily: 'system-ui, -apple-system, sans-serif' },
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #e2e8f0', paddingBottom: '14px' },
  headerTitle: { margin: 0, fontSize: '20px', color: '#1e293b' },
  closeBtn: { background: 'none', border: 'none', fontSize: '28px', color: '#94a3b8', cursor: 'pointer', lineHeight: '1' },
  progressContainer: { margin: '20px 0 10px 0' },
  progressText: { fontSize: '13px', color: '#64748b', fontWeight: '600' },
  progressBarOuter: { width: '100%', height: '6px', backgroundColor: '#f1f5f9', borderRadius: '999px', marginTop: '6px', overflow: 'hidden' },
  progressBarInner: { height: '100%', backgroundColor: '#3b82f6', transition: 'width 0.3s ease-in-out' },
  form: { display: 'flex', flexDirection: 'column', gap: '20px' },
  stepContainer: { display: 'flex', flexDirection: 'column', gap: '10px' },
  stepTitle: { margin: 0, color: '#0f172a', fontSize: '18px' },
  label: { fontSize: '14px', color: '#475569', lineHeight: '1.4' },
  textarea: { width: '100%', height: '110px', padding: '12px', borderRadius: '8px', border: '1px solid #cbd5e1', fontSize: '15px', color: '#334155', resize: 'none', boxSizing: 'border-box', outline: 'none', fontFamily: 'inherit' },
  dateInput: { width: '100%', padding: '12px', borderRadius: '8px', border: '1px solid #cbd5e1', fontSize: '16px', color: '#334155', boxSizing: 'border-box', outline: 'none', fontFamily: 'inherit' },
  
  // Contenedor de revisión
  reviewContainer: { display: 'flex', flexDirection: 'column', gap: '14px', backgroundColor: '#f8fafc', padding: '16px', borderRadius: '8px', border: '1px solid #e2e8f0', maxHeight: '320px', overflowY: 'auto' },
  reviewItem: { borderBottom: '1px solid #e2e8f0', paddingBottom: '10px' },
  reviewItemHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
  
  // Botón pequeño de edición rápida
  editBtn: {
    background: 'none',
    border: 'none',
    color: '#3b82f6',
    fontSize: '12px',
    fontWeight: '600',
    cursor: 'pointer',
    padding: '4px 8px',
    borderRadius: '4px',
    backgroundColor: '#eff6ff',
    transition: 'all 0.1s ease'
  },

  reviewText: { margin: '6px 0 0 0', fontSize: '14px', color: '#334155', whiteSpace: 'pre-wrap', lineHeight: '1.5' },
  actions: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '10px' },
  btn: { padding: '10px 22px', borderRadius: '6px', border: 'none', fontSize: '14px', fontWeight: '600', cursor: 'pointer', transition: 'all 0.2s ease' },
  btnBackActive: { backgroundColor: '#f1f5f9', color: '#475569' },
  btnNextActive: { backgroundColor: '#c44c46', color: '#ffffff' },
  btnSubmitActive: { backgroundColor: '#06415b', color: '#ffffff' }, 
  btnDisabled: { backgroundColor: '#e2e8f0', color: '#94a3b8', cursor: 'not-allowed' }
};